import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { GeneralCsvReportProvider } from "presentation/store/GeneralCsvReport/GeneralCsvReportProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import GeneralCsvReportMaintenance from "presentation/view/section/GeneralCsvReport/GeneralCsvReportMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const GeneralCsvReportContMain = () => {
    return <ANAInfoWrapper permission={Permission.GENERAL_CSV_REPORT_MAINTENANCE}>
        <MessageBarWrapper>
            <GeneralCsvReportProvider>
                <GridStyles />
                <GeneralCsvReportMaintenance />
            </GeneralCsvReportProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default GeneralCsvReportContMain;